<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-toolbar-title>ロープライス計算サイト</v-toolbar-title>
      </div>
    </v-app-bar>

    <v-main>
      <LprTaisaku/>
    </v-main>
  </v-app>
</template>

<script>
import LprTaisaku from './components/LprTaisaku';

export default {
  name: 'App',

  components: {
    LprTaisaku,
  }
};
</script>
